"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function NotImplementedFromJSON(json) {
    return NotImplementedFromJSONTyped(json, false);
}
exports.NotImplementedFromJSON = NotImplementedFromJSON;
function NotImplementedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !runtime_1.exists(json, 'code') ? undefined : json['code'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
    };
}
exports.NotImplementedFromJSONTyped = NotImplementedFromJSONTyped;
function NotImplementedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'message': value.message,
    };
}
exports.NotImplementedToJSON = NotImplementedToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm90SW1wbGVtZW50ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvTm90SW1wbGVtZW50ZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUFFSCx3Q0FBK0M7QUFxQi9DLFNBQWdCLHNCQUFzQixDQUFDLElBQVM7SUFDNUMsT0FBTywyQkFBMkIsQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDcEQsQ0FBQztBQUZELHdEQUVDO0FBRUQsU0FBZ0IsMkJBQTJCLENBQUMsSUFBUyxFQUFFLG1CQUE0QjtJQUMvRSxJQUFJLENBQUMsSUFBSSxLQUFLLFNBQVMsQ0FBQyxJQUFJLENBQUMsSUFBSSxLQUFLLElBQUksQ0FBQyxFQUFFO1FBQ3pDLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsTUFBTSxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUN4RCxTQUFTLEVBQUUsQ0FBQyxnQkFBTSxDQUFDLElBQUksRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDO0tBQ3BFLENBQUM7QUFDTixDQUFDO0FBVEQsa0VBU0M7QUFFRCxTQUFnQixvQkFBb0IsQ0FBQyxLQUE2QjtJQUM5RCxJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7UUFDckIsT0FBTyxTQUFTLENBQUM7S0FDcEI7SUFDRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDaEIsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxNQUFNLEVBQUUsS0FBSyxDQUFDLElBQUk7UUFDbEIsU0FBUyxFQUFFLEtBQUssQ0FBQyxPQUFPO0tBQzNCLENBQUM7QUFDTixDQUFDO0FBWkQsb0RBWUMifQ==